(ns ui.shortcut
  (:require [ui.utils :refer [clsx]]
            [applied-science.js-interop :as js-interop]
            [clojure.string]))

(defn process-system-keyboard-symbols [shortcut]
  (let [mac? (re-find #"Mac" (js-interop/get js/navigator :platform))]
    (cond-> shortcut
      mac? (clojure.string/replace #"cmd" "⌘")
      mac? (clojure.string/replace #"mod" "⌘")
      (not mac?) (clojure.string/replace #"cmd" "Ctrl")
      (not mac?) (clojure.string/replace #"mod" "Ctrl"))))

(defn keycap [{:keys [class title]} key]
  [:kbd {:title title
         :class (clsx "inline-block min-w-5 h-5 px-1 leading-5 text-center rounded-xs bg-kleene-text/10"
                      class)}
   key])

(defn wrap-individual-key [keycap? index key]
  (let [class (clsx "font-sans text-inherit"
                    {"uppercase" (= 1 (count key))})]
    (if keycap?
      ^{:key index} [keycap {:class class} key]
      [:kbd {:key index :class class} key])))

(defn shortcut [{:keys [keys class keycap?]}]
  [:kbd {:class (clsx "text-inherit font-sans flex flex-row gap-1 opacity-50"
                      class)}
   (->> keys
       (map process-system-keyboard-symbols)
       (map-indexed (partial wrap-individual-key keycap?)))])

(defn tooltip-content [{:keys [content keys]}]
  [:div {:class "flex flex-row"}
   [:span content]
   [shortcut {:class "ml-4"
              :keys keys}]])
